import { LOCATION_INITIALIZED } from '@angular/common';
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmbeddedDataService } from '@allianz/ngx-aem-integration';
import { AemConfiguration } from '../config/aem-configuration.type';
import { getFirstArrayValue } from '../utils';

export const initializeTranslations =
  (translate: TranslateService, injector: Injector, embeddedDataService: EmbeddedDataService<{ foo: 'bar' }, AemConfiguration>) =>
  (): Promise<unknown> =>
    new Promise<unknown>((resolve, reject) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

      locationInitialized
        .then(() => {
          const language: string =
            embeddedDataService.ContextConfiguration?.language || getFirstArrayValue(navigator.language.split('-')) || 'pl';

          if (!language) {
            console.warn(`W4A Schedule meeting:: Missing language`);

            return;
          }

          translate.addLangs(['en', 'pl', language]);
          translate.setDefaultLang(language);
          void translate.use(language);
          void resolve(language);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
